import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { EmptyRouteComponent } from "./empty-route/empty-route.component";
import { GlobalNavRouting } from "./global-nav-routing";
import { RootComponent } from "./root-component/root.component";
import { AccountManagementResolver } from "./services/account-management.resolver";
import { OktaCallbackComponent } from "src/app/okta-callback/okta-callback.component";

const appRoutes: Routes = [
  {
    path: "",
    component: RootComponent,
    pathMatch: "full",
  },
  {
    path: 'implicit/callback',
    component: OktaCallbackComponent,
    canActivate: [AccountManagementResolver]
  },

  /**will remove these redirection once transaction route is updated in global nav*/
    //start: temporary change- need to change route in global nav
   {
    path:"apps/tfb_acctmgmt/account-management/transaction-history",
    redirectTo:"/apps/tfb_acctmgmt/account-management/transactions/transaction-history"
  },
  {
    path:"apps/tfb_acctmgmt/account-management/transaction-details",
    redirectTo:"/apps/tfb_acctmgmt/account-management/transactions/transaction-details"
  },
  {
    path:"apps/tfb_acctmgmt/account-management/transactions",
    redirectTo:"/apps/tfb_acctmgmt/account-management/transactions/transaction-history",
    pathMatch: "full"
  },
//end

  {
    path: "apps/tfb_acctmgmt",
    redirectTo: '/apps/tfb_acctmgmt/account-management',
    pathMatch: 'full'
  },
  {
    path: "apps/tfb_acctmgmt/account-management",
    children: GlobalNavRouting,
  },
  {
    path: "**",
    component: EmptyRouteComponent,
    pathMatch: "full",
  },
];
@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(appRoutes, {
    // onSameUrlNavigation: 'reload'
  })],
  declarations: [],
})
export class AppRoutingModule {}
